import { render, staticRenderFns } from "./MailContentDialog.vue?vue&type=template&id=136335a2"
import script from "./MailContentDialog.vue?vue&type=script&lang=js"
export * from "./MailContentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports